module.exports = "img/flags/SI.ff4013b.png";